import axios from 'axios';
// import store from './store'
import router from './router/router'
// import { MessageBox } from 'element-ui'

//axios配置
axios.defaults.timeout = 8000;
// axios.defaults.baseURL = 'http://192.168.2.117:8070';
axios.defaults.baseURL = 'http://106.15.106.130:8070';
axios.defaults.withCredentials = true;

//http request 拦截器
axios.interceptors.request.use(
    config => {
        if (sessionStorage.token) {    //判断token是否存在
            config.headers.Authorization = sessionStorage.token; //将token设置成请求头
            config.headers.tc_app_type = '';
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
)

//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.error && response.data.error.code === 403) {
            window.sessionStorage.removeItem('token');
            // MessageBox.confirm(
            //     '您已被登出，可以取消继续留在该页面，或者重新登录',
            //     '警告', {
            //     confirmButtonText: '重新登录',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     router.replace({
            //         path: '/login' // 到登录页重新获取token
            //     })
            // })
            router.replace({
                path: '/login' // 到登录页重新获取token
            })
        } else {
            return response;
        }
    },
    error => {
        return Promise.reject(error);
    }
)

export default axios;
